// extracted by mini-css-extract-plugin
module.exports = {"label":"Dinning_label__rg3tk"};